/**
 * A health pickup: a small glowing green cross that gently bobs/spins, hidden
 * while the slot is on cooldown. Static position; no interpolation needed.
 */
import { TransformNode } from "@babylonjs/core/Meshes/transformNode.js";
import { MeshBuilder } from "@babylonjs/core/Meshes/meshBuilder.js";
import { StandardMaterial } from "@babylonjs/core/Materials/standardMaterial.js";
import { Color3 } from "@babylonjs/core/Maths/math.color.js";
import type { Scene } from "@babylonjs/core/scene.js";

export interface Pickup {
  setActive(on: boolean): void;
  spin(dt: number): void;
}

export const createPickup = (scene: Scene, x: number, z: number): Pickup => {
  const root = new TransformNode("pickup", scene);
  root.position.set(x, 0.7, z);

  const mat = new StandardMaterial("pickupMat", scene);
  mat.disableLighting = true;
  mat.emissiveColor = new Color3(0.25, 0.95, 0.45);

  const bar1 = MeshBuilder.CreateBox("pickup-h", { width: 0.7, height: 0.22, depth: 0.22 }, scene);
  const bar2 = MeshBuilder.CreateBox("pickup-v", { width: 0.22, height: 0.7, depth: 0.22 }, scene);
  for (const b of [bar1, bar2]) {
    b.parent = root;
    b.material = mat;
    b.isPickable = false;
  }

  let t = 0;
  return {
    setActive(on: boolean): void {
      root.setEnabled(on);
    },
    spin(dt: number): void {
      t += dt;
      root.rotation.y += dt * 1.5;
      root.position.y = 0.7 + Math.sin(t * 2) * 0.12;
    },
  };
};
